<template>
  <SharedLayout>
    <!-- Preloader Start -->
   
    <!-- Back To Top Start -->
    <button id="back-top" class="back-to-top">
      <i class="fa-regular fa-arrow-up"></i>
    </button>

    <!-- Mouse Cursor Start -->
    <div class="mouse-cursor cursor-outer"></div>
    <div class="mouse-cursor cursor-inner"></div>

    <!-- fix-area Start -->
  

    <!-- Sidebar Area Here -->
   


    <!-- search-wrap Start -->
  

    <!-- About-Section Start -->
    <section class="about-section section-padding fix">
      <div class="container">
        <div class="about-wrapper-2">
          <div class="row g-4 align-items-center">
            <div class="col-xl-4 col-lg-6 col-md-6">
              <div class="about-left-content">
                <h4>Our Journey</h4>
                <p>At Bloom & Luxe, fashion isn’t just about what you wear — it’s about how you feel.
We’re redefining everyday elegance with carefully crafted outfits that speak style and sophistication.
Whether it’s sleek suits for him, chic dresses for her, or playful fits for the little ones, we’ve got something for every occasion.
                </p>
                <div class="content">
                  <h3>Our Mission</h3>
                  <p>
                    At Bloom & Luxe, our mission is to empower individuals and families to express their unique style with confidence and comfort.
We strive to make quality fashion accessible to everyone — blending elegance, affordability, and inclusivity.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-6">
              <div class="about-image">
                <img src="/assets/img/shop/about.png" alt="img">
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-6">
              <div class="about-right">
                <h3>
                  About Company
                </h3>
                <p>
                  
                  Founded with a passion for fashion and a love for detail, Bloom & Luxe is your go-to fashion destination for men, women, and children.
We believe that true style is inclusive — that luxury and comfort should belong to everyone.
Each piece we curate blends modern design with everyday practicality, helping you look and feel your best, wherever you go.
                </p>
                <!-- <div class="info-text">
                  <h6>Co-founder</h6>
                  <img src="/assets/img/about/sign.png" alt="img">
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- video-bg-Section Start -->
    

    <!-- About-Section Start -->
    <section class="about-section section-padding fix">
      <div class="container">
        <div class="about-wrapper style-2">
          <div class="row g-4">
            <div class="col-xl-6">
              <div class="about-image">
                <img src="/assets/img/shop/ear-1.jpeg" alt="img" class="wow fadeInUp" data-wow-delay=".3s">
                <div class="about-image-2">
                  <img src="/assets/img/product/bag4.jpg" alt="img" class="wow fadeInUp" data-wow-delay=".5s">
                </div>
              </div>
            </div>
            <div class="col-xl-6">
              <div class="about-content">
                <div class="section-title style-2">
                  <h6 class="sub-title wow fadeInUp">
                    Unity Collection
                  </h6>
                  <h2 class="wow fadeInUp" data-wow-delay=".3s">
                    Shop our limited
                    Edition Collaborations
                  </h2>
                </div>
                <div class="text">
                  <p class="wow fadeInUp" data-wow-delay=".5s">
                    Our Limited Edition Collaborations bring you one-of-a-kind pieces created with top designers and fashion creatives. Each collection is crafted in small batches — once they’re gone, they’re gone for good. Shop now and own a look that’s uniquely yours.
                  </p>
                  <a href="/shop" class="theme-btn wow fadeInUp" data-wow-delay=".7s">Shop Now <i class="fa-regular fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonial-Section Start -->
    <section class="testimonial-section fix">
      <div class="testimonial-wrapper">
        <div class="row g-0">
          <div class="col-xl-6">
            <div class="testimonial-image">
              <img src="/assets/img/shop/sheabutter.jpeg" alt="img">
            </div>
          </div>
          <div class="col-xl-6">
            <div class="testimonial-content">
              <div class="icon">
                <img src="/assets/img/icon/quate.svg" alt="img">
              </div>
              <h3>What Customers Say</h3>
              <div class="swiper testimonial-slider-2">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="info-content">
                      <h4>Emma Clarke</h4>
                      <span>Adelaide</span>
                      <p>
                      Such a unique store! The outfit I bought is fashionable, <br> comfortable, and really stands out. I get compliments every time I wear it. Highly recommend!  
                      </p>
                      
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="info-content">
                      <h4>Jack Mitchell</h4>
                      <span>Melbourne</span>
                      <p>
                        
                        Great quality clothing and beautiful designs.  <br>Shipping was quick and the packaging was lovely.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="array-buttons">
                <button class="array-prev">
                  <i class="fa-solid fa-arrow-up"></i>
                </button>
                <button class="array-next">
                  <i class="fa-solid fa-arrow-down"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </section>

    <!-- footer-section Start -->
  </SharedLayout>
</template>

<script>
import SharedLayout from '@/components/SharedLayout.vue';
import { onMounted } from 'vue'

export default {
  name: 'AboutPage',
  components: {
    SharedLayout
  },
  setup() {
    onMounted(() => {
      // Initialize jQuery plugins and custom JS
      if (window.$) {
        // Sidebar Toggle
        $(".offcanvas__close,.offcanvas__overlay").on("click", function() {
          $(".offcanvas__info").removeClass("info-open");
          $(".offcanvas__overlay").removeClass("overlay-open");
        });
        $(".sidebar__toggle").on("click", function() {
          $(".offcanvas__info").addClass("info-open");
          $(".offcanvas__overlay").addClass("overlay-open");
        });

        // Sticky Header
        $(window).on("scroll", function() {
          if ($(this).scrollTop() > 250) {
            $("#header-sticky").addClass("sticky");
          } else {
            $("#header-sticky").removeClass("sticky");
          }
        });

        // Sidebar Area
        $("#openButton").on("click", function(e) {
          e.preventDefault();
          $("#targetElement").removeClass("side_bar_hidden");
        });
        $("#closeButton").on("click", function(e) {
          e.preventDefault();
          $("#targetElement").addClass("side_bar_hidden");
        });

        // Video Popup
        $('.img-popup').magnificPopup({
          type: "image",
          gallery: { enabled: true },
        });
        $('.video-popup').magnificPopup({
          type: 'iframe'
        });

        // Counterup
        $(".count").counterUp({
          delay: 15,
          time: 4000,
        });

        // Wow Animation
        new WOW().init();

        // Nice Select
        $('select').niceSelect();

        // Swiper Sliders
        if($('.testimonial-slider-2').length > 0) {
          const testimonialSlider2 = new Swiper(".testimonial-slider-2", {
            loop: true,
            slidesPerView: 1,
            speed: 3000,
            autoplay: { delay: 3000, disableOnInteraction: false },
            navigation: { nextEl: ".array-next", prevEl: ".array-prev" },
          });
        }

        // Search Popup
        $(".search-trigger").on("click", function (e) {
          e.preventDefault();
          $(".search-wrap").animate({ opacity: "toggle" }, 500);
          $(".nav-search, #search-close").addClass("open");
        });
        $(".search-close").on("click", function (e) {
          e.preventDefault();
          $(".search-wrap").animate({ opacity: "toggle" }, 500);
          $(".nav-search, #search-close").removeClass("open");
        });

        // Back to Top
        $(window).on('scroll', function() {
          if ($(this).scrollTop() > 20) {
            $("#back-top").addClass("show");
          } else {
            $("#back-top").removeClass("show");
          }
        });
        $(document).on('click', '#back-top', function() {
          $('html, body').animate({ scrollTop: 0 }, 800);
          return false;
        });

        // Preloader
        $(window).on('load', function() {
          $(".preloader").addClass('loaded');
          $(".preloader").delay(600).fadeOut();
        });
      }
    });

    return {};
  }
}
</script>